<template>
  <div id="DefaultDiamond">
    <section class="default-text">
      <div class="container-fluid">
        <div class="row">
          <div class="col text-center p-0">
            <h1 class="m-md-0">
              {{ $t("DefaultDiamond.text.header") }}
            </h1>
          </div>
        </div>
        <div class="row set-mlr d-md-none d-lg-none">
          <div class="col-12 d-md-none set-text" v-for="n in 4" v-bind:key="n">
            {{ $t("DefaultDiamond.text-mob.text-" + n) }}
          </div>
          <div
            class="d-none d-md-block col-md-4 col-lg-3 offset-lg-0 set-text"
            v-for="n in 8"
            v-bind:key="n"
            :class="n % 2 ? 'offset-md-2' : 'offset-md-1'"
          >
            {{ $t("DefaultDiamond.text.text-" + n) }}
          </div>
        </div>
      </div>
    </section>
    <div class="default-carat-slider" v-if="search.carat.data.length > 0">
      <div class="container-md">
        <div class="row">
          <div class="col-12">
            <vue-slider
              v-model="search.carat.value"
              :data="search.carat.data"
              :min="search.carat.from"
              :max="search.carat.till"
              :marks="true"
              :tooltip="'none'"
              :included="true"
              :process="false"
              :dot-attrs="{ 'aria-label': 'Ab Größe/Gewicht' }"
              @change="searchDefaultDiamonds()"
              ref="slider"
              class="set-vue-slider"
            ></vue-slider>
          </div>
        </div>
      </div>
    </div>
    <div class="default-diamond-list" v-if="defaultDiamond.quantity > 0">
      <div class="container-md p-0">
        <Carousel
          class="carousel text-center"
          :gap="5"
          :items-to-show="2"
          :wrap-around="true"
          :touchDrag="true"
          :mouseWheel="true"
          :snap-align:="'center'"
          :breakpoints="{
            576: {
              itemsToShow: 3.5,
            },
            768: {
              itemsToShow: 4,
            },
            992: {
              itemsToShow: 5,
              wrapAround: false,
              enabled: false,
              autoplay: false,
              snapAlign: 'start',
            },
          }"
        >
          <Slide
            v-for="(item, index) in defaultDiamond.list"
            v-bind:key="index"
            class="col-auto"
          >
            <div
              :class="[item.id == search.id ? 'active' : '']"
              @click="updateStockSearch(item.id)"
              class="card card-diamond"
            >
              <div class="card-image">
                <img
                  :src="
                    appUrl +
                    '/img/assets/stones/forms/600/' +
                    (item.id == search.id ? 'grey' : 'white') +
                    '/a.jpg'
                  "
                  :style="'width: ' + diamondImageSize + 'rem'"
                  class="card-img-top rounded"
                  alt=""
                />
              </div>
              <div class="card-body">
                <h5 class="card-title">
                  {{ $t("DefaultDiamond.quality.id_" + item.id) }} -
                  {{ item.text }}
                </h5>
                <p class="card-text">
                  <span>{{ item.price }}</span>
                  <span>
                    <a
                      :href="configuratorUrl + item.articleNu + '/'"
                      :class="[shopId > 10000 ? 'col-2 order-icon' : 'd-none']"
                    >
                      <img
                        :src="appUrl + '/img/icons/order.svg'"
                        alt="Fast Order"
                        class="rounded"
                      />
                    </a>
                  </span>
                </p>
                <a
                  class="btn btn-md"
                  :class="[
                    item.id == search.id
                      ? 'btn-real-diamond-stock'
                      : 'btn-outline-real-diamond-stock',
                  ]"
                  @click="updateStockSearch(item.id)"
                >
                  {{ $t("DefaultDiamond.text.search") }}
                </a>
              </div>
            </div>
          </Slide>
          <template #addons>
            <Navigation />
          </template>
        </Carousel>
        <div class="container-md">
          <div class="row">
            <div class="col text-center p-0 mt-5">
              <router-link
                class="btn btn-grey btn-search"
                @click="resetSite"
                :to="{ name: 'diamond-stock' }"
              >
                {{ $t("Main.text.stock") }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader v-else />
  </div>
  <DiamondStock
    :showMenu="false"
    :stockSearch="stockSearch"
    :key="{ stockSearch }"
    :sType="1"
  />
</template>
<script>
import Loader from "@/components/SpinnerLoader.vue";
import DiamondStock from "@/components/DiamondStock";
import DAODefaultDiamond from "@/assets/DAO/DefaultDiamond";
import DAODiamond from "@/assets/DAO/Diamond";
import Logger from "@/assets/Helper/Logger";
import store from "@/store";

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";

import { onMounted, reactive, ref, computed, watchEffect } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
export default {
  name: "default-diamond",
  components: {
    Loader,
    VueSlider,
    DiamondStock,
    Carousel,
    Slide,
    Navigation,
  },
  props: {
    sSearch: {
      type: Object,
    },
  },
  setup(props) {
    const stockSearch = reactive(props.sSearch);
    const search = reactive({
      carat: reactive({
        value: store.getters["setSearchData/getCarat"],
        from: 0,
        till: 0,
        data: [],
      }),
      id: ref(store.getters["setSearchData/getQualityId"]),
    });
    const defaultDiamond = reactive({
      list: ref({}),
      quantity: ref(0),
      search: ref({}),
    });

    function updateStockSearch(qualityId) {
      let colorAndPurityId =
        DAODefaultDiamond.getColorAndPurityByQualityId(qualityId);
      search.id = qualityId;
      store.dispatch("setSearchData/setDefaultStockSearch", {
        color: colorAndPurityId.colorId + "_id",
        purity: colorAndPurityId.purityId + "_id",
      });
      store.dispatch("setSearchData/setNavSite", 1);
      searchDefaultDiamonds(false);

      if (window.innerWidth < 991) {
        document
          .getElementById("DiamondStock")
          .scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    async function searchDefaultDiamonds(init = false) {
      defaultDiamond.quantity = 0;

      if (!init) {
        store.dispatch("setSearchData/setNavSite", 1);
      }

      setTimeout(() => {
        DAODefaultDiamond.getList(
          store.getters["config/getCountry"],
          search.carat.value
        ).then(async (response) => {
          if (Object.keys(response.list).length > 0) {
            defaultDiamond.list = response.list;
            defaultDiamond.quantity = response.list.length;
            defaultDiamond.search = response.search;
            let length = response.search.carat.length;

            if (search.carat.from === 0 || search.carat.till === 0) {
              search.carat.from = parseFloat(response.search.carat[0].id);
              search.carat.till = parseFloat(
                response.search.carat[length - 1].id
              );
            }

            for (let i = 0; i < length; i++) {
              search.carat.data[i] = parseFloat(
                response.search.carat[i].id
              ).toFixed(1);
            }

            await getDiamondsArticleNr();
          }
        });
      }, 0);
    }

    function getDiamondImageSize() {
      if (stockSearch["carat"][0] > 1.5 && stockSearch["carat"][0] <= 2) {
        return 10;
      } else if (
        stockSearch["carat"][0] > 1 &&
        stockSearch["carat"][0] <= 1.5
      ) {
        return 9.5;
      } else if (
        stockSearch["carat"][0] > 0.7 &&
        stockSearch["carat"][0] <= 1
      ) {
        return 9;
      } else if (
        stockSearch["carat"][0] > 0.5 &&
        stockSearch["carat"][0] <= 0.7
      ) {
        return 8.5;
      } else if (
        stockSearch["carat"][0] > 0.4 &&
        stockSearch["carat"][0] <= 0.5
      ) {
        return 8;
      } else if (
        stockSearch["carat"][0] > 0.3 &&
        stockSearch["carat"][0] <= 0.4
      ) {
        return 7.5;
      } else {
        return 7;
      }
    }

    async function getDiamondsArticleNr() {
      if (defaultDiamond.quantity > 0) {
        defaultDiamond.list.forEach((item, index) => {
          defaultDiamond.list[index].articleNu = "";
          DAODiamond.getItemnumber(item.defStoneId).then(
            (itemnumber) => {
              if (typeof itemnumber === "string" && itemnumber !== false) {
                defaultDiamond.list[index].articleNu = itemnumber;
              }
            },
            (alerts) => {
              if (typeof alerts == "object" && alerts.length > 0) {
                Logger.debug("Alerts", alerts);

                for (let key in alerts) {
                  Notification.create(alerts[key].title, alerts[key].text);
                }
              } else {
                Logger.debug("No alerts set", alerts);
              }
            }
          );
        });
      }
    }

    function resetSite() {
      store.dispatch("setSearchData/setNavSite", 1);
    }

    watchEffect(() => {
      store.dispatch("setSearchData/setQualityId", search.id);
      store.dispatch("setSearchData/setCarat", search.carat.value);
    });

    onMounted(() => {
      searchDefaultDiamonds(true);
    });

    return {
      search,
      stockSearch,
      defaultDiamond,
      updateStockSearch,
      resetSite,
      searchDefaultDiamonds,
      appUrl: computed(() => store.getters["config/getAppUrl"]),
      shopId: computed(() => store.getters["config/getActiveShop"]),
      diamondImageSize: computed(() => getDiamondImageSize()),
      configuratorUrl: computed(() => {
        return typeof window.diamondStockConfig.configuratorUrl === "string" &&
          window.diamondStockConfig.configuratorUrl !== ""
          ? window.diamondStockConfig.configuratorUrl
          : "/";
      }),
    };
  },
};
</script>
<style lang="scss" scoped>
#DefaultDiamond {
  min-height: 53rem;

  .order-icon {
    img {
      display: inline-block;
      margin-left: 1rem;
      width: 3rem;

      @media #{$sm} {
        margin-left: 1rem;
      }

      @media #{$md} {
        margin-left: 2rem;
      }
    }
  }

  .default-text {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
    background-color: #f0f0f0;
    border-top: 0.1rem solid $greyColor;
    border-bottom: 0.1rem solid $greyColor;

    .set-mlr {
      @media #{$lg} {
        margin-left: calc(var(--bs-gutter-x));
        margin-right: calc(var(--bs-gutter-x));
      }
    }

    .set-text {
      text-align: center;
    }

    .col-md-4 {
      @media #{$md} {
        text-align: left;
        list-style-type: disc;
        display: list-item !important;
      }
    }

    @media #{$md} {
      padding-top: 2rem;
      padding-bottom: 2rem;
    }

    @media #{$lg} {
      padding-top: 2.5rem;
      padding-bottom: 2.5rem;
    }
  }

  .default-carat-slider {
    margin: 3rem 0;
    padding: 0 0.75rem 2rem;
  }

  .default-diamond-list {
    .carousel {
      padding: 0;

      @media #{$lg} {
        margin: auto;
      }
    }

    .card-diamond {
      width: 100%;
      cursor: pointer;
      text-align: center;
      padding: 0 0.5rem 1rem 0.5rem;

      &.active {
        border-color: $realDiamondColor;
        .card-image {
          background-color: #f0f0f0;
        }
      }

      .card-image {
        padding: 1rem 0;

        img {
          display: inline-flex;
          width: 7rem;
        }
      }

      .card-title {
        height: 6rem;
        padding: 1rem 0 0 0;

        @media #{$md} {
          height: 5rem;
        }
      }

      .card-text {
        font-size: 1.1em;
        font-weight: bold;

        @media #{$sm} {
          padding: 1rem 0;
        }

        @media #{$md} {
          padding: 1rem 0.25rem;
        }
      }

      .btn {
        padding: 0.5rem;
        text-transform: uppercase;
      }

      &:first-child {
        @media #{$lg} {
          width: calc(20% - 0.5rem);
          margin: 0 0.5rem 0 0 !important ;
        }

        @media #{$xl} {
          width: calc(20% - 1rem);
          margin: 0 1rem 0 0 !important ;
        }
      }

      &:last-child {
        @media #{$lg} {
          width: calc(20% - 0.5rem);
          margin: 0 0 0 0.5rem !important ;
        }

        @media #{$xl} {
          width: calc(20% - 1rem);
          margin: 0 0 0 1rem !important ;
        }
      }

      @media #{$lg} {
        width: calc(20% - 1rem);
        margin: 0 0.5rem !important;
        display: inline-flex;
      }

      @media #{$xl} {
        width: calc(20% - 2rem);
        margin: 0 1rem !important;
      }
    }

    .btn-search {
      margin: 0 0 3rem;

      @media #{$md} {
        max-width: 35rem;
      }
    }

    .card-diamond {
      cursor: pointer;
      text-align: center;
      padding: 0 0 1rem 0;

      &.active {
        border-color: $realDiamondColor;

        .card-image {
          background-color: #f0f0f0;
          padding: 1rem 0;

          img {
            display: inline-flex;
            width: 7rem;
          }
        }
      }

      &:last-child {
        @media #{$lg} {
          margin-right: 0;
        }
      }
    }

    .default-data {
      cursor: pointer;
      color: $brandGoldColor;
      font-weight: 600;
      font-size: 1.2rem;
      margin-bottom: 1rem;

      .stone {
        text-align: left;

        @media #{$sm} {
          text-align: center;
        }
      }

      .stone,
      .fast-order {
        img {
          &.rounded {
            width: 100%;
            max-width: 3rem;

            @media #{$lg} {
              max-width: 4rem;
            }
          }
        }

        @media (max-width: 575px) {
          padding-top: 0.4rem;
        }

        @media (max-width: 499px) {
          padding-top: 0.3rem;
        }

        @media (max-width: 374px) {
          padding-top: 0.2rem;
        }
      }

      .quality-data,
      .price {
        @media #{$sm} {
          padding-top: 0.6rem;
        }

        @media #{$lg} {
          padding-top: 1rem;
        }
      }

      .quality-data {
        text-decoration: underline;
      }

      .price {
        &.set-pr {
          padding-right: 2rem;

          @media (max-width: 374px) {
            padding-right: 1.5rem;
          }

          @media #{$sm} {
            padding-right: 3rem;
          }

          @media #{$xl} {
            padding-right: 2.5rem;
          }
        }

        @media (max-width: 575px) {
          padding-top: 0.75rem;
        }
      }

      &.set-pt {
        .stone,
        .fast-order {
          @media (max-width: 575px) {
            padding-top: 0;
          }
        }

        .quality-data,
        .price {
          @media (max-width: 575px) {
            padding-top: 0.55rem;
          }
        }
      }

      &.active {
        color: #000;
        background: #f0f0f0;

        .quality-data {
          text-decoration: none;
        }
      }

      & > .row {
        @media (min-width: 550px) {
          width: 90%;
          margin-left: 5%;
        }

        @media #{$sm} {
          width: auto;
          margin-left: calc(-0.5 * var(--bs-gutter-x));
        }
      }

      @media (max-width: 374px) {
        font-size: 1.15rem;
      }

      @media (min-width: 530px) {
        font-size: 1.3rem;
      }

      @media #{$sm} {
        @media (max-width: 624px) {
          font-size: 1.15rem;
        }
      }

      @media #{$md} {
        font-size: 1.4rem;
      }
    }
  }

  @media #{$md} {
    min-height: 47rem;
  }

  @media #{$lg} {
    min-height: 47rem;
  }
}
</style>
